<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="姓名" prop="name">
              <el-input clearable disabled v-model="form.name" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" prop="sex">
              <el-select disabled v-model="form.sex" style="width: 100%">
                <el-option
                  v-for="item in sexList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄" prop="age">
              <el-input clearable disabled v-model="form.age" maxlength="100"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="联系电话" prop="tel">
              <el-input clearable disabled v-model="form.tel" maxlength="100"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="地址" prop="address">
              <el-input clearable disabled v-model="form.address" maxlength="100"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            
              <div v-for="(item, index) in form.familyMemberList" :key="index">
                <el-form-item label="监护人" prop="address" v-if="item.isGuardian==2">
                  <el-input clearable style="width: 40%;margin-right: 20%;" disabled v-model="item.name" maxlength="100"></el-input>

                  <el-input clearable style="width: 40%;" disabled v-model="item.tel" maxlength="100"></el-input>
                </el-form-item>
              </div>
              
                <el-form-item label="紧急联系人" prop="address" >
                  <div v-for="(item, index) in form.familyMemberList" :key="index" style="margin-bottom: 10px;" >
                    <el-input v-if="item.isEmergencyContact==2" clearable style="width: 40%;margin-right: 20%;" disabled v-model="item.name" maxlength="100"></el-input>

                    <el-input v-if="item.isEmergencyContact==2" clearable style="width: 40%;" disabled v-model="item.tel" maxlength="100"></el-input>
                  </div>
                </el-form-item>
             
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input disabled type="textarea" :rows="2" v-model="form.description"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import { getSmartDeviceResumeElderlyInfo } from '@/api/nursingHome/artificalDevice';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [],
      sexList: [
        {
          id: "1",
          name: '男',
        },
        {
          id: "2",
          name: '女',
        },
      ],
      form: {
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode: '',
      },
      formRules: {
        consumableName: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    initData() {
      getSmartDeviceResumeElderlyInfo({
        id: this.row.id,
      }).then((res) => {
        this.form = res.data;
        
      });
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
